var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { BwElement } from './base/bw-element.js';
import './bw-tag.js';
function formatMmSs(seconds) {
    const s = Math.max(0, Math.floor(seconds));
    const mm = Math.floor(s / 60);
    const ss = s % 60;
    return `${mm}:${String(ss).padStart(2, '0')}`;
}
let BwSetlistCard = class BwSetlistCard extends BwElement {
    constructor() {
        super(...arguments);
        this.position = 0;
        this.song = null;
        this.status = 'idle';
        this.nowLabel = 'NOW';
        this.nextLabel = 'NEXT';
        this.mode = 'stage';
        this._onClick = () => {
            this.dispatchEvent(new CustomEvent('bw-setlist-card-select', {
                detail: { song: this.song },
                bubbles: true, composed: true,
            }));
        };
        this._onKeyDown = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this._onClick();
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.addEventListener('click', this._onClick);
        this.addEventListener('keydown', this._onKeyDown);
        if (!this.hasAttribute('role'))
            this.setAttribute('role', 'button');
        if (!this.hasAttribute('tabindex'))
            this.setAttribute('tabindex', '0');
    }
    disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('keydown', this._onKeyDown);
        super.disconnectedCallback();
    }
    render() {
        const song = this.song;
        const metaParts = [];
        if (song?.key)
            metaParts.push(song.key);
        if (song?.bpm)
            metaParts.push(`${song.bpm} bpm`);
        if (song?.durationSec)
            metaParts.push(formatMmSs(song.durationSec));
        const meta = metaParts.length > 0 ? metaParts.join(' · ') : (song?.metaText ?? '');
        return html `
      <span class="bw-sc-num">${this.position}</span>
      <div class="bw-sc-body">
        <div class="bw-sc-name">${song?.name ?? '—'}</div>
        <div class="bw-sc-meta">${meta}</div>
      </div>
      <div class="bw-sc-chip-slot">
        ${this.status === 'now'
            /* NOW/NEXT tags are NEUTRAL (2026-07-23 review #8 / two-accent
               palette): amber is reserved for signals/chords, red for the
               recording semantic. The now-state reads through the row's
               silver fill; the tag is a quiet neutral label. */
            ? html `<bw-tag variant="filled" size="sm">${this.nowLabel}</bw-tag>`
            : this.status === 'next' && this.mode === 'stage'
                ? html `<bw-tag variant="ghost" size="sm">${this.nextLabel}</bw-tag>`
                : nothing}
      </div>
    `;
    }
};
__decorate([
    property({ type: Number, reflect: true })
], BwSetlistCard.prototype, "position", void 0);
__decorate([
    property({ attribute: false })
], BwSetlistCard.prototype, "song", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwSetlistCard.prototype, "status", void 0);
__decorate([
    property({ type: String, attribute: 'now-label' })
], BwSetlistCard.prototype, "nowLabel", void 0);
__decorate([
    property({ type: String, attribute: 'next-label' })
], BwSetlistCard.prototype, "nextLabel", void 0);
__decorate([
    property({ type: String, reflect: true })
], BwSetlistCard.prototype, "mode", void 0);
BwSetlistCard = __decorate([
    customElement('bw-setlist-card')
], BwSetlistCard);
export { BwSetlistCard };
//# sourceMappingURL=bw-setlist-card.js.map